// import '../js/EsunMobileCA.js';

declare const esunMCA: any;

const useEsunMCA = () => {
    const SendMessage = (type: number = 0, message?: string) => {
        let embed = esunMCA.CheckAppEmbedStatus();
        esunMCA.InitSDK(embed.device);
        esunMCA?.SendMessage(type, message || '網頁發生錯誤，請重新嘗試');
    };

    /**
     * @todo 判斷是否為E櫃台WebView
     * @returns
     */
    const WebViewDetect = (): boolean => {
        try {
            const embed = window.esunMCA.CheckAppEmbedStatus();

            if (embed.code === 1) {
                // Web
                return false;
            } else {
                // WebView
                window.esunMCA.InitSDK(embed.device);
                return true;
            }
        } catch (e) {
            return false;
        }
    };
    return {
        SendMessage,
        WebViewDetect
    };
};

export default useEsunMCA;
